import { useCallback } from 'react';
import type { SettingItemKey } from '../constants';
import { useLogAnalyticsEvent } from 'shared/src/hooks';

export const useLogClickItem = () => {
  const analyticsEvent = useLogAnalyticsEvent();

  return useCallback(
    (key: SettingItemKey) => {
      switch (key) {
        case 'shippingAddress':
          analyticsEvent({
            name: 'CLICK_CHANGE_SHIPPING_ADDRESS',
          });
          return;
        case 'ablyPay':
          analyticsEvent({
            name: 'CLICK_ABLYPAY_SETTINGS',
          });
          return;
        case 'logout':
          analyticsEvent({
            name: 'CLICK_LOGOUT',
          });
          return;
        default:
          return;
      }
    },
    [analyticsEvent],
  );
};
